import { AnyAction } from 'redux';
import { UploadedPricingSummary } from 'src/types/mccMncPricing';

type SelectedCustomer = {
  value: number;
  label: string;
};

interface MccMncPricingState {
  customerId?: number;
  customerOptions: SelectedCustomer[];
  customersLoaded: boolean;
  uploadPricingDialogOpen: boolean;
  noAddedPricingFileError: boolean;
  attachment: {
    uploading: boolean;
    data?: $TSFixMe;
    id?: $TSFixMe;
    link?: string;
    mpId?: $TSFixMe;
    validSize: boolean;
    failed: boolean;
    source?: $TSFixMe;
    error?: $TSFixMe;
    name?: string;
  };
  uploadedPricingSummary: UploadedPricingSummary | null;
  uploadingPricing: boolean;
}

const initialState: MccMncPricingState = {
  customerId: undefined,
  customerOptions: [],
  customersLoaded: false,
  uploadPricingDialogOpen: false,
  noAddedPricingFileError: false,
  attachment: {
    uploading: false,
    data: undefined,
    id: undefined,
    validSize: true,
    failed: false,
    source: null,
    name: undefined,
  },
  uploadedPricingSummary: null,
  uploadingPricing: false,
};

export default function reducer(state: MccMncPricingState = initialState, action: AnyAction): MccMncPricingState {
  switch (action.type) {
    case 'SET_CUSTOMER_ID': {
      return {
        ...state,
        customerId: action.payload,
      };
    }
    case 'SET_CUSTOMER_OPTIONS': {
      return {
        ...state,
        customerOptions: action.payload,
      };
    }
    case 'SET_CUSTOMERS_LOADED': {
      return {
        ...state,
        customersLoaded: action.payload,
      };
    }
    case 'SET_UPLOAD_PRICING_DIALOG_OPEN': {
      return {
        ...state,
        uploadPricingDialogOpen: action.payload,
      };
    }
    case 'SET_NO_UPLOADED_PRICING_FILE_ERROR': {
      return {
        ...state,
        noAddedPricingFileError: action.payload,
      };
    }
    case 'SET_PRICING_FILE': {
      return {
        ...state,
        attachment: {
          ...state.attachment,
          data: action.payload,
          //validSize: validSize(action.payload.size, state.payloadType),
        },
      };
    }
    case 'SET_PRICING_FILE_UPLOADING': {
      return {
        ...state,
        attachment: {
          ...state.attachment,
          uploading: true,
        },
      };
    }
    case 'SET_PRICING_FILE_UPLOADED': {
      return {
        ...state,
        attachment: {
          ...state.attachment,
          uploading: false,
          id: action.payload.id,
          link: action.payload.link,
          name: action.payload.name,
        },
      };
    }
    case 'RESET_PRICING_FILE_UPLOADED': {
      return {
        ...state,
        attachment: {
          ...state.attachment,
          uploading: false,
          data: undefined,
          id: undefined,
          link: undefined,
          name: undefined,
        },
      };
    }
    case 'SET_PRICING_UPLOADING': {
      return {
        ...state,
        uploadingPricing: action.payload,
      };
    }
    case 'SET_UPLOADED_PRICING_SUMMARY': {
      return {
        ...state,
        uploadedPricingSummary: action.payload,
      };
    }
    default:
      return {
        ...state,
      };
  }
}